import { trimSp } from "@components/config/helpers";
import useSalesTelephone from "@components/_hooks/useSalesTelephone";
import Typography from "@mui/material/Typography"
import dynamic from "next/dynamic";
import { useSelector } from "react-redux"

const ParseHtml = dynamic(() => import('../../Custom/ParseHtml'))

const ContactOfficeDetails = () => {
    const { global_settings } = useSelector((state) => state.globalReducer);
    const sales_telephone = useSalesTelephone();

    return (
        <ul>
            <Typography className="fw-bold f-size_4" color="primary" variant="h6" component="h6">Head Office</Typography>
            <li>
                <ParseHtml html={global_settings.sales_address}/>
            </li>
            <br/>

            <Typography className="fw-bold f-size_4" color="primary" variant="h6" component="h6">Sales</Typography>
            <li>
                <a href={`tel:${trimSp(sales_telephone)}}`} className="brand_telephone_link">{sales_telephone}</a>
            </li>

            <li>
                <strong>24hr phone coverage</strong>
            </li>

            <li>
                {global_settings.sales_fax}
            </li>

            <br/>

            <Typography className="fw-bold f-size_4" color="primary" variant="h6" component="h6">Accounts</Typography>
            <li>
                <a href={`tel:${global_settings.accounts_telephone}}`} className="brand_telephone_link">{global_settings.accounts_telephone}</a>
            </li>

            <li>
                {global_settings.accounts_fax}
            </li>

            <li>
                <a href={`mailto:${global_settings.accounts_email}}`} className="brand_telephone_link">{global_settings.accounts_email}</a>
            </li>

        </ul>
    )
}

export default ContactOfficeDetails